<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  name: "app",
};
</script>

<style scope>
#app {
  font-family: "Prompt", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}
</style>

